
import { Component, Vue } from 'vue-property-decorator'
import { ApplyListDto, getCompanyIsApplySet, getMerchantsApplyList, modifyIsAutoPass } from '@/api/customerManage'
import { Getter } from 'vuex-class'

@Component({
  name: 'CustomerApply'
})
export default class CustomerApply extends Vue {
  @Getter companyId!: string

  refreshing = false
  loading = false
  finished = false
  isAutoPass = true
  params = {
    companyId: '',
    pageIndex: 1,
    pageSize: 20
  }
  applyList: ApplyListDto[] = []

  created () {
    this.params.companyId = this.companyId
    this.getList()
  }

  getList () {
    // 有查看的权限的时候,才调用获取列表数据
    // if(!this.$action('query',0)) return false
    getMerchantsApplyList(this.params).then((res) => {
      this.applyList = res.data.records || []
      if (this.applyList.length >= res.data.totalRecords) {
        this.finished = true
      } else {
        this.finished = false
      }
    }).finally(() => {
      this.refreshing = false
    })
    getCompanyIsApplySet({  }).then(res => {
      this.isAutoPass = res.data.isAutoPass === 1
    })
  }

  /**
   * 下拉刷新
   * */
  onRefresh () {
    this.params.pageIndex = 1
    this.refreshing = true
    this.getList()
  }

  /**
   * 上拉加载更多
   */
  onLoad () {
    this.params.pageIndex++
    this.loading = true
    getMerchantsApplyList(this.params).then((res) => {
      this.loading = false
      this.applyList = this.applyList.concat(res.data.records)
      if (this.applyList.length >= res.data.totalRecords) {
        this.finished = true
      }
    }).finally(() => {
      this.refreshing = false
    })
  }

  toHandle (val: ApplyListDto) {
    this.$router.push({
      path: '/customerApplyHandle',
      query: {
        merchantsId: val.merchantsId,
        companyId: val.companyId,
        applyId: val.applyId,
        msg: val.applyMessage,
        companyCode: val.companyCode
      }
    })
  }

  changePass () {
    // if (!this.$action('setting')) {
    //   this.isAutoPass=!this.isAutoPass
    //   return false
    // }

    this.isAutoPass=!this.isAutoPass

    const params = {
      isAutoPass: this.isAutoPass
    }
    modifyIsAutoPass(params).then(() => {
      this.$toast.success(`已${this.isAutoPass ? '设置' : '取消'}自动通过客户申请`)
    })
  }

  toValet () {
    this.$router.push({
      path: '/valetRegistration',
    })
  }
}
